import React, { useEffect } from 'react';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';

import './Popup.css';

export default function Popup(props) {
    const { t } = useTranslation();
    const { open, closeModal, children, maxWidth, fullWidth } = props;

    return (
        <Dialog open={open} maxWidth={maxWidth ? maxWidth : 'lg'} fullWidth={fullWidth ? true : false}>
            <div className={'modalContentSS'}>
                <div className={'modalBody'}>{children}</div>

                <div className="modalCloseBtn">
                    <div className="centerButton">
                        <button type="button" className="btn btn-default" onClick={closeModal}>
                            <p>{t('AboutTheProject.ModalCloseButton')}</p>
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}
